import orgServices from '../../../services/notisphere/organization'
import ProviderModal from './ProviderModal'
import { ORGANIZATION_STATUS } from '../../../misc/commons'
import ViewModal from '../../../components/part/shared/PreviewViewModal'
import { _findObj } from '../../../misc/genericFunctions'
import {
    AG_GridCustomizedTableHeaders_Key,
    Notisphere_ProviderList_AgGrid
} from '../../../misc/tableHeaders'
import _ from 'lodash'
// Add a constant for the default filter flag
const PROVIDER_STATUS_DEFAULT_FILTER_KEY = 'notisphere_provider_status_default_applied'

export default {
    components: {
        ProviderModal,
        ViewModal,
    },
    data() {
        return {
            columnDefs: null,
            gridOptions: {
                onFilterChanged: this.onFilterChanged,
                onSortChanged: this.onSortChanged,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: this.onGridReady, // Add this
            },
            search: {
                name: null,
                notisphere_id: null,
                add1: null,
                add2: null,
                city: null,
                state: null,
                zip: null,
                stt: null,
                sites: null,
                number_of_hospitals: null,
                number_of_non_acute_sites: null,
            },
            gridApi: null,
            columnApi: null,
            searchQuery: { pageNumber: 1, pageSize: 50, sort: null, colId: null },
            delay: 700,
            clicks: 0,
            timer: null,
            total: 0,
            viewModalKey: 0,
            items: [],
            header: [],
            defaultHeader: [],
            org_status: ORGANIZATION_STATUS,
            providerModalKey: 0,
            table_Connection_Data: this.$store.state.CustomizedHeaders.filter(
                (s) => s.userId == this.$store.state.user.id
            )[0],
            globalSearchText: '',
            hasUserModifiedStatusFilter: false, // Add flag to track user modifications
        }
    },
    created() {
        this.rowModelType = 'serverSide'
    },
    beforeMount() {
        this.columnDefs = Notisphere_ProviderList_AgGrid
    },
    methods: {
        // Add new method to handle grid ready
        onGridReady(params) {
            this.gridApi = params.api
            this.columnApi = params.columnApi
            // Don't apply default filter here, let fetchData handle it
        },

        // Add method to apply default status filter
        applyDefaultStatusFilter() {
            const defaultFilterApplied = localStorage.getItem(PROVIDER_STATUS_DEFAULT_FILTER_KEY)

            if (!defaultFilterApplied || defaultFilterApplied === 'false') {
                // Get current filter model
                const currentFilterModel = this.gridApi.getFilterModel() || {}

                // Apply default filter to show only 'Active' status
                currentFilterModel.stt = {
                    filterType: 'set',
                    values: ['Active']
                }

                this.gridApi.setFilterModel(currentFilterModel)

                // Mark that default filter has been applied
                localStorage.setItem(PROVIDER_STATUS_DEFAULT_FILTER_KEY, 'true')
                this.hasUserModifiedStatusFilter = false
            }
        },

        // Modified method to check if user modified status filter
        isStatusFilterModified(filterModel) {
            const currentStatusFilter = filterModel?.stt?.values
            const defaultStatusFilter = ['Active']

            if (!currentStatusFilter && !this.hasUserModifiedStatusFilter) {
                return false
            }

            if (!currentStatusFilter || currentStatusFilter.length !== defaultStatusFilter.length) {
                return true
            }

            return !currentStatusFilter.every(status => defaultStatusFilter.includes(status))
        },

        getContextMenuItems(params) {
            let that = this
            const defaultItems = params.defaultItems
            const filteredItems = defaultItems.filter((item) => item !== 'export')
            const searchquery = JSON.parse(JSON.stringify(this.searchQuery))
            const customMenuItem = {
                name: 'Excel Export',
                action: async function () {
                    const email = that.$store.state.user.email

                    // Handle status filter mapping for export
                    const statusFilter = params.api.getFilterModel()?.stt?.values
                    let mappedStatusFilter = null
                    if (statusFilter && statusFilter.length > 0) {
                        const statusMap = {
                            'Active': 'ACTIVE',
                            'Deactivated': 'DEACTIVATED',
                            'Pending': 'PENDING'
                        }
                        mappedStatusFilter = statusFilter.map(status => statusMap[status] || status)
                    }

                    const query_param = {
                        ...searchquery,
                        search: that.globalSearchText,
                        sortField: searchquery.colId,
                        sortDirection: searchquery.sort,
                        name: params.api.getFilterModel()?.name?.filter,
                        add1: params.api.getFilterModel()?.add1?.filter,
                        add2: params.api.getFilterModel()?.add2?.filter,
                        city: params.api.getFilterModel()?.city?.filter,
                        state: params.api.getFilterModel()?.state?.filter,
                        zip: params.api.getFilterModel()?.zip?.filter,
                        notisphere_id:
                    params.api.getFilterModel()?.notisphere_id?.filter,
                        sites: params.api.getFilterModel()?.sites?.filter,
                        number_of_hospitals:
                    params.api.getFilterModel()?.number_of_hospitals?.filter,
                        number_of_non_acute_sites:
                    params.api.getFilterModel()?.number_of_non_acute_sites
                        ?.filter,
                        stt: mappedStatusFilter,
                        filterModel: params.api.getFilterModel(),
                        email: email,
                    }
                    const resp = await orgServices.downloadAgGridProviderAccountXLSXRecall(query_param)
                    if (!resp.error) {
                        that._showOk(resp.data.d.message, {
                            variant: 'success',
                            title: 'Message',
                            buttonTitle: 'Ok',
                        })
                    }
                },
                icon: '<span class="ag-icon ag-icon-excel"></span>',
            }
            const allItems = [...filteredItems, customMenuItem]
            return allItems
        },
        saveState(params) {
            this.table_Connection_Data.Notisphere_Login.Provider_Headers =
              params.columnApi.getColumnState()
            localStorage.setItem(
                AG_GridCustomizedTableHeaders_Key,
                JSON.stringify(this.$store.state.CustomizedHeaders)
            )
        },
        applyState(params) {
            const userId = this.$store.state.user.id
            const tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.find(s => s.userId === userId)[0]
            let columnState = tableState?.Notisphere_Login?.Provider_Headers
            if (columnState) {
                const actionCol = columnState.find(col => col.colId === 'actions')
                columnState = columnState.filter(col => col.colId !== 'actions')
                if (actionCol) {
                    columnState.push(actionCol)
                }
                params.columnApi.applyColumnState({
                    state: columnState,
                    applyOrder: true
                })
            }
            // Don't apply default status filter here, let setFilterModel handle it
        },

        setFilterModel(params) {
            const userId = this.$store.state.user.id
            var tableState = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key))?.filter(s => s.userId == userId)[0]
            var filterModel = tableState?.Notisphere_Login?.Providers_Filters

            if (filterModel) {
                // Check if user has modified status filter before
                const defaultFilterApplied = localStorage.getItem(PROVIDER_STATUS_DEFAULT_FILTER_KEY)
                const hasStatusFilter = filterModel.stt && filterModel.stt.values && filterModel.stt.values.length > 0

                if (hasStatusFilter) {
                    // User has a saved status filter, mark as modified
                    this.hasUserModifiedStatusFilter = true
                    localStorage.setItem(PROVIDER_STATUS_DEFAULT_FILTER_KEY, 'user_modified')
                    params.api.setFilterModel(filterModel)
                } else if (!defaultFilterApplied || defaultFilterApplied === 'false') {
                    // No saved status filter and default not applied yet, apply default
                    const modifiedFilterModel = { ...filterModel }
                    modifiedFilterModel.stt = {
                        filterType: 'set',
                        values: ['Active']
                    }
                    params.api.setFilterModel(modifiedFilterModel)
                    localStorage.setItem(PROVIDER_STATUS_DEFAULT_FILTER_KEY, 'true')
                    this.hasUserModifiedStatusFilter = false
                } else {
                    // Apply saved filters without status filter
                    params.api.setFilterModel(filterModel)
                }
            } else {
                // No saved filters, apply default status filter if not applied yet
                const defaultFilterApplied = localStorage.getItem(PROVIDER_STATUS_DEFAULT_FILTER_KEY)
                if (!defaultFilterApplied || defaultFilterApplied === 'false') {
                    params.api.setFilterModel({
                        stt: {
                            filterType: 'set',
                            values: ['Active']
                        }
                    })
                    localStorage.setItem(PROVIDER_STATUS_DEFAULT_FILTER_KEY, 'true')
                    this.hasUserModifiedStatusFilter = false
                }
            }
        },

        onSortChanged(event) {
            this.saveState(event)
            this.fetchData(event)
        },

        onFilterChanged(event) {
            // Check if user modified the status filter
            const filterModel = event.api.getFilterModel()
            if (this.isStatusFilterModified(filterModel)) {
                this.hasUserModifiedStatusFilter = true
                // Update localStorage to prevent future default filter applications
                localStorage.setItem(PROVIDER_STATUS_DEFAULT_FILTER_KEY, 'user_modified')
            }

            // Save the current filter state including status filter
            this.saveFilterState(event)
            this.saveState(event)
            this.fetchData(event)
        },

        // Add new method to save filter state
        saveFilterState(params) {
            const userId = this.$store.state.user.id
            const filterModel = params.api.getFilterModel()

            // Find or create user's table state
            let tableStates = JSON.parse(localStorage.getItem(AG_GridCustomizedTableHeaders_Key)) || []
            let userTableState = tableStates.find(s => s.userId === userId)

            if (!userTableState) {
                userTableState = { userId: userId, Notisphere_Login: {} }
                tableStates.push(userTableState)
            }

            if (!userTableState.Notisphere_Login) {
                userTableState.Notisphere_Login = {}
            }

            // Save the filter model
            userTableState.Notisphere_Login.Providers_Filters = filterModel

            // Update localStorage
            localStorage.setItem(AG_GridCustomizedTableHeaders_Key, JSON.stringify(tableStates))

            // Update store state
            this.$store.state.CustomizedHeaders = tableStates
        },

        fetchData(params) {
            this.applyState(params)
            this.setFilterModel(params) // Apply saved filters or default filter

            let that = this
            that.gridApi = params.api
            that.columnApi = params.columnApi


            const datasource = {
                getRows(params) {
                    that.searchQuery.colId = params.request?.sortModel[0]?.colId
                    that.searchQuery.sort = params.request?.sortModel[0]?.sort
                    that.search.name = params.request?.filterModel?.name?.filter
                    that.search.add1 = params.request?.filterModel?.add1?.filter
                    that.search.add2 = params.request?.filterModel?.add2?.filter
                    that.search.city = params.request?.filterModel?.city?.filter
                    that.search.state = params.request?.filterModel?.state?.filter
                    that.search.zip = params.request?.filterModel?.zip?.filter
                    that.search.notisphere_id = params.request?.filterModel?.notisphere_id?.filter
                    that.search.sites = params.request?.filterModel?.sites?.filter
                    that.search.number_of_hospitals = params.request?.filterModel?.number_of_hospitals?.filter
                    that.search.number_of_non_acute_sites = params.request?.filterModel?.number_of_non_acute_sites?.filter

                    // Handle status filter mapping from display values to backend values
                    const statusFilter = params.request?.filterModel?.stt?.values
                    if (statusFilter && statusFilter.length > 0) {
                        const statusMap = {
                            'Active': 'ACTIVE',
                            'Deactivated': 'DEACTIVATED',
                            'Pending': 'PENDING'
                        }
                        that.search.stt = statusFilter.map(status => statusMap[status] || status)
                    } else {
                        that.search.stt = null
                    }

                    that.search.filterModel = that.gridApi.getFilterModel()
                    orgServices
                        .findProviders({
                            ...that.searchQuery,
                            search: that.globalSearchText,
                            sortField: params.request?.sortModel[0]?.colId,
                            sortDirection: params.request?.sortModel[0]?.sort,
                            ...that.search,
                        })
                        .then((resp) => {
                            if (!resp.error) {
                                for (var i = 0; i < resp.data.d.c.length; i++) {
                                    if (resp.data.d.c[i].document.length == 0) {
                                        resp.data.d.c[i].document = null
                                    }
                                }
                                that.total = resp.data.d.t
                                if (that.total == 0) {
                                    that.gridApi.showNoRowsOverlay()
                                } else {
                                    that.gridApi.hideOverlay()
                                }
                                return resp.data.d.c
                            }
                        })
                        .then((response) => {
                            params.successCallback(response)
                        })
                        .catch((error) => {
                            console.error(error)
                            params.failCallback()
                        })
                },
            }
            params.api.setServerSideDatasource(datasource)
        },
        deletePendingProvider(item, e) {
            this._showConfirm(
                'You are about to delete this organization, this cannot be undone.'
            ).then((confirm) => {
                if (confirm) {
                    orgServices.deletePendingProvider(item.id).then((resp) => {
                        if (!resp.error) {
                            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
                            this._showToast('Deleted successfully!')
                        }
                    })
                }
            })
            //e.stopPropagation()
        },
        findProviderAccountCSVReport() {
            orgServices
                .downloadProviderAccountCSVRecall({
                    ...this.searchQuery,
                    sortField: this.searchQuery.colId,
                    sortDirection: this.searchQuery.sort,
                    ...this.search,
                })
                .then((resp) => {})
        },
        findProviderAccountXLSXReport() {
            orgServices
                .downloadProviderAccountXLSXRecall({
                    ...this.searchQuery,
                    sortField: this.searchQuery.colId,
                    sortDirection: this.searchQuery.sort,
                    ...this.search,
                })
                .then((resp) => {})
        },
        findProviderAccountUsageXLSXReport() {
            orgServices.downloadConsolidatedProviderReport().then((resp) => {})
        },
        findProviderDetailedActivtyXLSXReport() {
            orgServices.downloadDetailedProviderActivityReport().then(resp => {
            })
        },
        onCellClicked(params) {
            if (params.colDef.field == 'status') {
                this.addMoreRespClick(params.data)
                return
            }
            if (params.column.colId === 'document') {
                if (params.event.target.dataset.action != undefined) {
                    if (params.event.target.dataset.action.includes('viewclick')) {
                        for (let i = 0; i <= params.data.document.length; i++) {
                            if (
                                params.event.target.dataset.action ===
                'viewclick_' + params.data.document[i].organization_document_id
                            ) {
                                return this.ViewClick(params.data.document[i])
                            }
                        }
                    }
                }
            }
            if (params.column.colId === 'actions') {
                if (params.event.target.dataset.action === 'edit') {
                    this.updateProvider(params.data)
                }
                if (params.event.target.dataset.action === 'delete') {
                    this.deletePendingProvider(params.data)
                }
                if (params.event.target.dataset.action === 'intake-settings') {
                    this.updateContactInfo(params.data)
                }
                return
            } else {
                this.updateProvider(params.data)
            }
        },
        updateContactInfo(val) {
            this.$router.push({
                name: 'noti_ContactInfo',
                params: { organizationId: val.id },
            })
        },
        ViewClick(val) {
            let data = []
            orgServices.getProvider(val.organization_id).then((resp) => {
                if (!resp.error) {
                    resp.data.d.document.forEach((x, i) => {
                        if (x.organization_document_id == val.organization_document_id) {
                            data = x
                        }
                    })
                    val = data
                    this.viewModalKey += 1
                    this.$nextTick(() => {
                        this.$refs.viewModal.forceRerenderInsert(val)
                    })
                }
            })
        },
        addMoreClick() {
            this.providerModalKey += 1
            this.$nextTick(() => {
                this.$refs.providerModal.forceRerenderInsert()
            })
        },
        updateProvider(payload, e = null) {
            this.providerModalKey += 1
            this.$nextTick(() => {
                this.$refs.providerModal.forceRerenderUpdate(payload.id)
            })
            if (e) {
                e.stopPropagation()
            }
        },
        onCompleted(type) {
            if (type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
        },
        debounceInput: _.debounce(function (searchStr) {
            this.searchQuery.pageNumber = 1
            if (searchStr.length >= 1) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            } else if (searchStr.length === 0) {
                this.fetchData({ api: this.gridApi, columnApi: this.columnApi })
            }
        }, 500),
        onGlobalSearchChange(inputVal) {
            this.globalSearchText = inputVal
            this.debounceInput(inputVal)
        },
    },
}
